module.exports = __webpack_public_path__ + "img/1e0a123.png";